import axios from 'axios';
import AppConfig from "../../../../../AppConfig";

let URL = AppConfig.HOST_API()+'rodzKal/';

export default {

    getKalendarze() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    addKalendarz(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editKalendarz(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteKalendarz(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/kalendarze/rodzajeKalendarzy/RodzajKalendarzyService.js